import type { FaireProductEntity } from "../../entity_types/product";

export const p_x42ytkz7z6: FaireProductEntity = {
  token: "p_x42ytkz7z6",
  type: "product",
  name: "Horny For Thrift Stores Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/fb10ccea7d609a4c3a069c61cc4492860dab817747b9ea6c1189ed72bce78105.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b6f662b7f231f357e0caba197ea8162389922b7736c0daad0378e6f290536fe1.jpeg",
    "https://cdn.faire.com/fastly/05aeb82c13a28829989bf77206058877bf4a0e6bed183698083a5845cd05a948.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/df75d5abb07a8463f27a8b0089779fd6cb09b20dbd6dee114113d57f72aca7b0.jpeg",
    "https://cdn.faire.com/fastly/699cb8a0db50a48931dc91b93e6d03cb4b4e096f8edf457523c7a13b1b99a1e4.jpeg",
    "https://cdn.faire.com/fastly/72bd53a60b7f781571e1ed5ec0eae3ecbc7be3b4046dd554168c0f9cb42d2bba.jpeg",
    "https://cdn.faire.com/fastly/f0b862008637b3d8478cf2129634a9b446697779c6aa0b0429ee43378747483b.jpeg",
    "https://cdn.faire.com/fastly/0514ec429cd63bbe7f8d11b9d5833256f25cc13a07da47d82ea676dec5c42303.jpeg"
  ],
  priceDollars: 6.75,
  description: "If the smell of dust and stale clothes gets you going, we can only imagine what happens when you turn someones trash into your treasure 🤤 . Splash some cold water on your face, wear these socks, and try not to climax in the bric-a-brac section 💦 \n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:56.085Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
